// arrayBufferToBase64
export function arrayBufferToBase64(buffer: ArrayBuffer) {
  // 创建一个Uint8Array视图
  const view = new Uint8Array(buffer);
  // 使用ArrayBuffer的byteLength属性确定数据的长度
  const len = view.byteLength;
  // 创建一个数组来收集字符
  const binaryStringArray = new Array(len);
  // 使用循环将Uint8Array转换为字符数组
  for (let i = 0; i < len; i++) {
    binaryStringArray[i] = String.fromCharCode(view[i]);
  }
  // 使用join方法将字符数组连接成字符串
  const binaryString = binaryStringArray.join('');
  return btoa(binaryString);
}
